




















import MyProfileView from "@/components/user/MyProfileView.vue";
import { Component, Vue } from "vue-property-decorator";
import api from "@/getinfo-api";
import { User as IUser } from "@/api/models/user";
import { getJWTPayload } from "@/getinfo-api/auth";
import { UserDocumentInfo as IUserDocumentInfo } from "@/api/models/user-document-info";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  components: { CBreadCrumbs, MyProfileView }
})
export default class ProfileView extends Vue {
  protected user!: IUser;
  documentInfo!: IUserDocumentInfo;

  data() {
    return {
      user: undefined,
      documentInfo: undefined
    };
  }
  protected get userId(): string {
    const payload = getJWTPayload();
    return payload ? payload.id : "Undefined id";
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "users" },
        label: this.$tc(this.$translate.Users)
      },
      {
        label: this.$converter.limitedOutput(this.user.fullName, 40)
      }
    ];
  }

  getUserInfo() {
    api.UsersApi.get(this.userId)
      .then(res => {
        this.user = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  getDocumentInformation() {
    api.UsersApi.getDocumentInfo(this.userId)
      .then((res: { data: IUserDocumentInfo }) => {
        this.documentInfo = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  mounted() {
    this.getUserInfo();
    this.getDocumentInformation();
  }
}
